
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","fill":"none"}},[_c('path',{attrs:{"d":"M17.596 4.68v8.718a1.868 1.868 0 0 1-1.868 1.868H3.274a1.868 1.868 0 0 1-1.868-1.868V4.681m16.19 0a1.868 1.868 0 0 0-1.868-1.869H3.274a1.868 1.868 0 0 0-1.868 1.869m16.19 0v.201a1.869 1.869 0 0 1-.888 1.591l-6.227 3.832a1.868 1.868 0 0 1-1.96 0L2.296 6.474a1.868 1.868 0 0 1-.889-1.59V4.68","stroke":"#363636","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}})])
      }
    
      }
    